import { EditorView } from '@codemirror/view';

/**
 * CodeMirror 6 theme that maps to Tailwind CSS variables from admin-console.
 * Supports light/dark mode via CSS custom properties.
 */
export const promptEditorTheme = EditorView.theme({
  '&': {
    fontSize: '14px',
    fontFamily: 'inherit',
  },
  '&.cm-focused': {
    outline: 'none',
  },
  '.cm-content': {
    fontFamily: 'inherit',
    padding: '8px 0',
    caretColor: 'hsl(var(--foreground))',
  },
  '.cm-cursor': {
    borderLeftColor: 'hsl(var(--foreground))',
  },
  '.cm-selectionBackground': {
    backgroundColor: 'hsl(var(--accent)) !important',
  },
  '&.cm-focused .cm-selectionBackground': {
    backgroundColor: 'hsl(var(--accent)) !important',
  },
  '.cm-gutters': {
    backgroundColor: 'hsl(var(--muted))',
    borderRight: '1px solid hsl(var(--border))',
    color: 'hsl(var(--muted-foreground))',
  },
  '.cm-activeLineGutter': {
    backgroundColor: 'hsl(var(--accent))',
  },
  '.cm-activeLine': {
    backgroundColor: 'hsl(var(--accent) / 0.3)',
  },
  '.cm-line': {
    padding: '0 8px',
  },
  // @ref() badge decoration
  '.cm-ref-tag': {
    backgroundColor: 'hsl(217 91% 90%)',
    color: 'hsl(224 76% 48%)',
    borderRadius: '4px',
    padding: '1px 4px',
    fontFamily: 'var(--font-mono, ui-monospace, monospace)',
    fontSize: '0.9em',
  },
  // Autocomplete tooltip
  '.cm-tooltip-autocomplete': {
    backgroundColor: 'hsl(var(--popover))',
    border: '1px solid hsl(var(--border))',
    borderRadius: '6px',
    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
  },
  '.cm-tooltip-autocomplete > ul > li': {
    padding: '4px 8px',
    fontSize: '13px',
  },
  '.cm-tooltip-autocomplete > ul > li[aria-selected]': {
    backgroundColor: 'hsl(var(--accent))',
    color: 'hsl(var(--accent-foreground))',
  },
});

/**
 * Dark mode overrides for @ref() badge.
 * Applied conditionally via `.dark` class on parent.
 */
export const promptEditorDarkOverrides = EditorView.theme({
  '.cm-ref-tag': {
    backgroundColor: 'hsl(217 50% 25%)',
    color: 'hsl(213 94% 78%)',
  },
}, { dark: true });
